import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    musicPlay: false,
    musicPath: ''
  },
  getters: {
    isWeiXin () {
      return /micromessenger/.test(navigator.userAgent.toLowerCase())
    },
    isApp () {
      function is_cosleep_ios () {
        let ios = false
        try {
          ios = false
        } catch (e) {
          //
        }
        return ios
      }

      function is_cosleep_android () {
        return false
      }

      return is_cosleep_android() || is_cosleep_ios()
    }
  },
  mutations: {
    musicSet (state, params) {
      state.musicPlay = params
    },
    musicPathSet (state, params) {
      state.musicPath = params
    }
  }
})
